



































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import CustomerService from "@/services/customer_service";
import { Validation } from "vuelidate";
import { CustomerSchema } from "@/models/customer_schema";
import { StoreModule } from "@/store/types";
import { CustomerActions } from "@/store/modules/customer/types";
import { namespace } from "vuex-class";
import { AuthError, APIError, GenericError } from "@/services/error_service";
import { EventBus } from "@/events";
import { VMoney } from "v-money";
import { salesYear, salesAmt } from "@/validators/custom";
@Component({
  directives: { money: VMoney },
})
export default class SalesYOY extends Vue {
  protected $v: Validation;
  protected customerService = new CustomerService();
  protected forDeletion: number[] = [];
  protected validated = false;
  protected salesData: { year: number | string; amt: number | string }[] = [];
  protected money = {
    decimal: ".",
    thousands: ",",
    prefix: "$",
    suffix: "",
    precision: 2,
    masked: false,
  };

  @Prop() data!: CustomerSchema;
  @(namespace(StoreModule.Customer).Action(CustomerActions.EditCustomer))
  editCustomer;
  @Validations()
  validations() {
    return {
      salesData: {
        $each: {
          year: {
            salesYear,
            oneEntryPerYear: this.oneEntryPerYear,
          },
          amt: {
            salesAmt,
          },
        },
      },
    };
  }

  created() {
    if (this.data.business_info) {
      if (this.data.business_info.sales_volume) {
        const data = JSON.parse(
          JSON.stringify(this.data.business_info.sales_volume)
        );
        this.salesData = data.map((d) => {
          (d.amt as number) = this.decimal.format(d.amt) as any;
          return d;
        });
      }
    }
  }

  beforeDestroy() {
    this.salesData = [];
  }

  public async handleSubmit(): Promise<void> {
    this.validated = false;
    if (this.salesData.length < 1) {
      this.$emit("close");
    } else if (this.forDeletion.length < 1) {
      this.validateNoDelete();
    } else {
      await this.validateDelete();
    }
  }

  /**
   * If there is atleast one item up for deletion, special validation is neccessary for every individual year object.
   * Need to check if delete checkbox is checked before validating fields (empty/invalid fields may be marked for deletion);
   *
   * If marked for deletion, handle delete logic.
   * If not marked for deletion, handle validation.
   *
   */
  public async validateDelete(): Promise<void> {
    if (this.salesData.length > 0) {
      // True === atleast one item that needs to be validated before submission
      this.validated = true;
      for (const [index, year] of this.salesData.entries()) {
        const deleteMe = this.forDeletion.some((d) => d == index);
        if (!deleteMe) {
          this.$v.salesData.$each.$iter[index].$touch();
          if (this.$v.salesData.$each.$iter[index].$invalid) {
            this.validated = false; // Form will not submit if any of the items switch boolean to false
          }
        } else {
          this.$v.salesData.$each.$iter[index].$reset();
        }
      }
      this.submitForm();
    } else {
      this.validated = true;
      this.submitForm();
    }
  }

  public validateNoDelete(): void {
    this.$v.salesData.$touch();
    if (!this.$v.$invalid) {
      this.validated = true;
      this.submitForm();
    }
  }

  public async submitForm(): Promise<void> {
    if (this.validated) {
      if (this.forDeletion.length > 0) {
        this.salesData = this.salesData.filter((d, i) => {
          if (!this.forDeletion.includes(i)) {
            return d;
          }
        });
      }

      this.salesData = this.salesData.map((d) => {
        const amt = (d.amt as string).replace(/\$|,/g, "");
        d.amt = Number(amt);
        d.year = parseInt(d.year as string, 10);
        return d;
      });
      await this.updateCustomer();
      EventBus.$emit("updateCustomer");
      this.$emit("close");
    }
  }

  get yearsSelect(): number[] {
    const d = new Date();
    const second = d.getFullYear();
    const first = 2010;
    const arr: number[] = [];
    for (let i = first; i <= second; i++) {
      arr.push(i);
    }
    arr.sort((a: number, b: number) => b - a);
    return arr;
  }

  public async updateCustomer(): Promise<void> {
    const reqObj = {
      business_info: this.data.business_info ? this.data.business_info : {},
    } as CustomerSchema;
    reqObj.business_info.sales_volume = this
      .salesData as CustomerSchema["business_info"]["sales_volume"];
    try {
      await this.customerService.updateCustomer(reqObj, this.data._id);
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      } else if (err instanceof APIError) {
        APIError.popup(err.message);
      } else {
        GenericError.popup(err.message);
      }
    }
  }

  private decimal = new Intl.NumberFormat("en-US", {
    minimumIntegerDigits: 1,
    minimumFractionDigits: 2,
  });

  public addItem(): void {
    const year = {
      year: 0,
      amt: 0,
    };
    this.salesData.push(year);
  }

  public oneEntryPerYear(year: string): boolean {
    const count = this.salesData.filter((item) => item.year == year).length;
    if (count < 2) {
      return true;
    } else {
      return false;
    }
  }
}
